import {
  NOT_OPEN_FOR_CLAIMS_REASON,
  NotOpenForClaimsReason,
} from '@savgroup-front-common/types/Claim';

import { SafeFormattedMessage } from '../../../formatters';
import messages from '../messages';

export const getNotOpenForClaimsReasonMessage = (
  notOpenForClaimsReason: NotOpenForClaimsReason,
) => {
  switch (notOpenForClaimsReason) {
    case NOT_OPEN_FOR_CLAIMS_REASON.MODEL_NOT_RETURNABLE:
      return SafeFormattedMessage(messages.modelNotReturnable);
    case NOT_OPEN_FOR_CLAIMS_REASON.MODEL_TYPE_NOT_RETURNABLE:
      return SafeFormattedMessage(messages.modelTypeNotReturnable);
    case NOT_OPEN_FOR_CLAIMS_REASON.SAMPLE:
      return SafeFormattedMessage(messages.sample);
    case NOT_OPEN_FOR_CLAIMS_REASON.SWAPPED:
      return SafeFormattedMessage(messages.swapped);
    case NOT_OPEN_FOR_CLAIMS_REASON.REFUNDED:
      return SafeFormattedMessage(messages.refunded);
    case NOT_OPEN_FOR_CLAIMS_REASON.OWNER_CHANGED:
      return SafeFormattedMessage(messages.ownerChanged);
    case NOT_OPEN_FOR_CLAIMS_REASON.SERVICE_BLOCKING_RETURN:
      return SafeFormattedMessage(messages.serviceBlockingReturn);
    default:
      return null;
  }
};
